export const JobStates = {
  RUNNING: "RUNNING",
  SUCCEEDED: "SUCCEEDED",
  QUEUING: "QUEUING",
  QUEUED: "QUEUED",
  INTERRUPTED: "INTERRUPTED",
  CANCELLING: "CANCELLING",
  CANCELLED: "CANCELLED",
  FAILED: "FAILED",
};

export const pollingInterval = 4000;

export const qlTag = "qlaunched";
